import Buyer from './Buyer';
export default Buyer;



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/ImageCarousel/PublicDisplay/Buyer/index.ts
// module id = 1383
// module chunks = 0 1 2 3